import { ThemeEvents } from '@theme/events';

class VariantDispatchStatus extends HTMLElement {
  #handleVariantUpdate = (event) => {
    const html = event.detail?.data?.html ?? event.detail?.html;

    if (!html || typeof html.querySelectorAll !== 'function') return;

    const source = Array.from(html.querySelectorAll('[data-variant-dispatch-status]')).find(
      (element) => element instanceof HTMLElement && element.dataset.blockId === this.dataset.blockId
    );

    if (!(source instanceof HTMLElement)) return;

    const sourceClone = source.cloneNode(true);
    this.replaceChildren(...sourceClone.childNodes);
    this.dataset.status = source.dataset.status ?? '';
    this.hidden = source.hidden;
  };

  connectedCallback() {
    document.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }
}

if (!customElements.get('variant-dispatch-status')) {
  customElements.define('variant-dispatch-status', VariantDispatchStatus);
}
